export default {
  // 通用按钮
  buttons: {
    create: '新建',
    edit: '编辑',
    delete: '删除',
    save: '保存',
    cancel: '取消',
    confirm: '确认',
    submit: '提交',
    loading: '加载中…',
    copy: '复制',
    share: '分享',
    remove: '移除',
    login: '登录',
    signup: '注册',
    startForFree: '免费开始',
    check: '检查',
    contactUsToModifyComments: '联系我们修改评论',
    confirmDelete: '确认删除',
  },

  // 登录相关
  auth: {
    dontHaveAccount: '还没有账号？',
    signUp: '注册',
    needHelp: '需要帮助？请联系',
    supportEmail: 'support@aha.inc',
  },

  // 移动端登录相关
  mobileAuth: {
    login: '登录',
    pleaseLogin: '请先登录',
    usingDesktopBrowser: '请使用桌面浏览器',
    getStartedMessage: '如需开始使用，请在桌面浏览器中打开 Head。',
    questionsMessage:
      '如有疑问或需要协助，欢迎加入我们的 Discord 社区，或联系',
    joinDiscord: '加入 Aha 的 Discord',
  },
  
  // 通用状态
  status: {
    active: '有效',
    inactive: '无效',
    pending: '待处理',
    completed: '已完成',
    failed: '失败',
    success: '成功',
    error: '错误',
  },
  
  // 通用消息
  messages: {
    copySuccess: '复制成功',
    copyFail: '复制失败',
    operationSuccess: '操作成功',
    operationFailed: '操作失败',
    confirmDelete: '确定要删除吗？',
    noData: '暂无数据',
    loading: '加载中…',
  },
  
  // 通用标签
  labels: {
    name: '名称',
    description: '描述',
    status: '状态',
    date: '日期',
    time: '时间',
    amount: '金额',
    quantity: '数量',
    price: '价格',
    total: '总计',
  },
  signOut: '退出登录',
  learnMore: '了解更多',
  YouTube: 'YouTube',
  Instagram: 'Instagram',
  TikTok: 'TikTok',
  LinkedIn: 'LinkedIn',
  Twitter: 'Twitter/X',
  collected: '已收货',
  reviews: '评论',
  loadMore: '加载更多',
  underReview: '待审核',
  reviewNotPassed: '评论未通过',
  gotIt: '知道了',
  influencers: '达人',
  report: '举报',
  template: '模板',
  refreshPage: '请刷新页面并重试。',
  reject: '拒绝',
  pendingActions: '待办事项',
};
